import { Routes } from '@angular/router';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { ListadoFacturaComponent } from './pages/listado-factura/listado-factura.component';
import { DetalleFacturaComponent } from './pages/detalle-factura/detalle-factura.component';

export const routes: Routes = [
    { 
        path: '', 
        redirectTo: 'pages', 
        pathMatch: 'full' },
    {
        path: 'pages',
        children: [
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full'
            },
            {
                path: 'home',
                loadChildren: () => import('../app/pages/home/home.module').then(m => m.HomeModule)
            },
            {
                path:'listadofacturas',
                component: ListadoFacturaComponent
            },
            {
                path: 'detallefactura',
                component: DetalleFacturaComponent
            }
        ]
    },
    { 
        path: '**', 
        component: PageNotFoundComponent
    }
];
